'use strict';

const Mn = require('backbone.marionette');
const MemberModel = require('common/domain/entity/member');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const ListTemplate = require('balus/ui/template/timeline/member-list.hbs');
const ItemTemplate = require('balus/ui/template/timeline/member-list-item.hbs');

const MemberItemView = Mn.View.extend({
    model: MemberModel,
    className: 'list-item',
    tagName: 'li',
    template: ItemTemplate,
    triggers: {
        'click': 'select'
    },
    regions: {
        icon: '.list-item-icon',
        title: '.list-item-header-title',
    },
    templateContext: function() {
        const projectRole = this.getOption('projectRoles').get(this.model.getRole());
        return {
            isProjectMember: this.model.get('isProjectMember'),
            role: projectRole ? projectRole.getName() : ''
        }
    },

    onRender: function() {
        const activeMembers = this.getOption('activeMembers');
        const isChecked = _.find(activeMembers, member => {
            return member.id == this.model.id;
        });
        if(this.model.get('active') || isChecked) {
            this.onSelect();
        }
        this.showChildView('icon', new GroupMemberIconView({
            model: this.model
        }));
        this.showChildView('title', new GroupMemberNameView({
            model: this.model
        }));
    },

    onSelect: function() {
        this.$el.toggleClass('is-active');
        if(this.$el.hasClass('is-active')) {
            this.$('.item-check').append('<i class="fa fa-check"></i>');
            this.triggerMethod('active', this.model);
        } else {
            this.$('.fa-check').remove();
            this.triggerMethod('inactive', this.model);
        }
    }
});

const MemberItemListView = Mn.CompositeView.extend({
    template: ListTemplate,
    tagName: 'div',
    childView: MemberItemView,
    childViewContainer: '.member-list',
    childViewOptions: function() {
        return {
            projectRoles: this.getOption('projectRoles'),
            activeMembers: this._activeMembers
        }
    },

    ui: {
        'addAllProjectMembers': '.add-all-project-members',
        'showGroupMembers': '.show-group-members'
    },
    events: {
        'click @ui.showGroupMembers': 'onShowGroupMembers'
    },
    triggers: {
        'click @ui.addAllProjectMembers': 'select:project:members'
    },
    templateContext: function() {
        return {
            moreMembers: this.getOption('moreMembers')
        }
    },

    updateMembers: function(members) {
        this.collection.add(members);
    },

    onShowGroupMembers: function() {
        this.ui.showGroupMembers.hide();
        this.trigger('show:group:members');
    },

    onChildviewActive: function(member) {
        if(!this._activeMembers) {
            this._activeMembers = {};
        }
        this._activeMembers[member.id] = member;
    },

    onChildviewInactive: function(member) {
        delete this._activeMembers[member.id];
    },

    getActiveMembers: function() {
        return this._activeMembers;
    }
});

module.exports = MemberItemListView;



// WEBPACK FOOTER //
// ./balus/ui/view/timeline/member-list.js